module.exports = __webpack_public_path__ + "static/media/LoaderAim.45bf8851.gif";